import { Component, Output, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { State } from '../core/state';

@Component({
    selector: 'load-more-footer',
    templateUrl: 'load-more-footer.component.html'
})
export class LoadMoreFooterComponent implements OnChanges {
    @Input() state: State;
    @Input() getMoreAction: (offset: number) => Promise<any>;
    @Input() getMoreObservableAction: (offset: number) => Observable<State>;
    @Input() isListEmpty: boolean;
    @Input() getMoreButtonText: string;
    @Input() requestLimit = 10;

    isLoading: boolean;
    isBottomReached: boolean;

    ngOnChanges(changes: SimpleChanges) {
        if (changes['state']) {
            const stateChange = changes['state'];
            if (!stateChange) {
                return;
            }

            if (this.state && this.state.total <= this.state.offset + this.state.count) {
                this.isBottomReached = true;
            }
        }
    }

    getMore() {
        if (!this.state) {
            return;
        }

        if (this.state.offset + this.state.count < this.state.total) {
            const offset = this.state.offset + this.requestLimit;

            this.isLoading = true;
            if (this.getMoreAction != null) {
                this.getMoreAction(offset).then(response => {
                    this.isLoading = false;

                    this.state = response.state;
                    if (this.state.count === 0) {
                        return;
                    }

                    if (this.state.offset + this.state.count >= this.state.total) {
                        this.isBottomReached = true;
                    }
                });
            } else if (this.getMoreObservableAction != null) {
                // TODO TEST
                this.getMoreObservableAction(offset).subscribe(state => {
                    this.isLoading = false;

                    this.state = state;
                    if (this.state.count === 0) {
                        return;
                    }

                    if (this.state.offset + this.state.count >= this.state.total) {
                        this.isBottomReached = true;
                    }
                });
            }
        }
    }

    goUp() {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    }
}



// WEBPACK FOOTER //
// D:/programming/Чижик_Api_Site_Sources-Electroline/front/src/app/common/load-more-footer.component.ts